import { render } from "./FormFooter.vue?vue&type=template&id=4037c02a"
import script from "./FormFooter.vue?vue&type=script&lang=js"
export * from "./FormFooter.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./FormFooter.vue?vue&type=style&index=0&id=4037c02a&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__